import * as yup from "yup";

// The backend requires at least one contact person (minItems: 1). Without the
// .min() the empty default array passed client validation and the user only got
// the raw schema error ("data/contactPersons must NOT have fewer than 1 items")
// back as a toast — .required() alone only rejects undefined/null.
export default yup
	.array()
	.required("CONTACT_PERSON_IS_REQUIRED")
	.min(1, "CONTACT_PERSON_IS_REQUIRED")
	.of(
		yup.object().shape({
			id: yup.string(),
			email: yup.string().email("EMAIL_NOT_VALID"),
			firstName: yup
				.string()
				.when("id", (id: string, schema: any) =>
					!id ? schema.required("FIRST_NAME_IS_REQUIRED") : schema
				),
		})
	);
